import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../redux/reduxActions';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { TreeList } from "@progress/kendo-react-treelist";

import products from "./TestDrawerData.json";

import './TestDrawerContent.css';
import EditableGrid from './EditableGrid';

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

type TestDrawerContentProps = PropsFromRedux & {
    type: number;
}


interface TestDrawerContentState {
    gridData: any;
    gs: React.CSSProperties
}

class TestDrawerContent extends React.Component<TestDrawerContentProps, TestDrawerContentState> {
    constructor(props: TestDrawerContentProps) {
        super(props);

        this.state = {
            gridData: products,
            gs: {}
        }

    }

    componentDidMount() {
        // this.updateDimensions();
        // window.addEventListener("resize", this.updateDimensions);

    }

    componentDidUpdate(prevProps: TestDrawerContentProps) {
        // if (prevProps.parentHeight !== this.props.parentHeight) {
        //     let gs = this.state.gs;
        //     gs.height = this.props.parentHeight
        //     this.setState({gs: this.props.parentHeight});
        // }
    }

    componentWillUnmount() {
    }


    updateDimensions = () => {
        let body = document.body;
        // let gg2 = document.documentElement;

        // let d = document,
        //     body = d.getElementById('appDiv');

        if (body) {
            var gs: React.CSSProperties = { ...this.state.gs };
            gs.height = body.clientHeight - 200;
            this.setState({
                gs: gs
            });
        }
    }


    render() {

                return (
                    <div className='anotherDiv'>

                    </div>
                );
        }
    }


export default connector(TestDrawerContent);
